import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../../../common/MobileGridCards.sass';

const PairedGoDeviceMobileCard = ({ row }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = row.go_camera_name || row.dv_vehicle_name;

	const baseData = [
		{ label: t(('Group (GO Device Group)').replace(/\s/g, '_')), value: row.go_device_groups },
		{ label: t(('IMEI/SN').replace(/\s/g, '_')), value: row.rl_serial_number },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<span className="mobile-card-name">{nameLabel}</span>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PairedGoDeviceMobileCard;
